import React from 'react';

const DocumentsScreen = () => {
  return (
    <div className="bg-white rounded-lg font-roboto">
      <div className="py-8 px-10 h-[calc(100vh-62px)]">
        <h1 className="text-lg font-medium">Documents</h1>
      </div>
    </div>
  );
};

export default DocumentsScreen;
